export class WFVendorContractRawDto {
    vendorContractId: number;
    crudAction: string;
}
